module.exports = __webpack_public_path__ + "images/lizard.svg";